module.exports = __webpack_public_path__ + "img/fb.c043886f.svg";